<div class="card">
  <div class="card-header">
    <h4>Edit Service Provider</h4>
  </div>
  <div class="row">
    <ul class="nav nav-tabs" id="myTab" role="tablist">
      <li class="nav-item" role="presentation">
        <a class="nav-link" [class.active]="activeTab === 'service'">Basic Information</a>
      </li>
      <li class="nav-item" role="presentation">
        <a class="nav-link" [class.active]="activeTab === 'commission'">Commission Setup</a>
      </li>
    </ul>
  </div>

  <div class="tab-content pt-2" id="myTabContent">
    <div id="service" class="tab-pane fade p-4 active show"
      [ngStyle]="{ 'display': activeTab === 'service'? 'block' : 'none'}">
      <form #editServiceProvider="ngForm" (ngSubmit)="saveServiceProvider(editServiceProvider.value)"
        [formGroup]="editServiceProviderForm">
        <div class="row">
          <div class="col-lg-12">
            <div class="card border-0 shadow-none text-center">
              <div class="card-body">
                <div class="row d-flex">
                  <div class="form-group col-md-3">
                    <label class="col-form-label" for="serviceProviderName">Service Provider Name <span
                        aria-hidden="true" class="symbol required" style="color:red;">*</span>
                    </label>
                    <input type="text" id="serviceProviderName" [readOnly]="!permissions.includes('Edit')"
                      autocomplete="off" class="form-control" (paste)="onPaste($event)"
                      (keypress)="OnlyCharacterAllowed($event)" required formControlName="serviceProviderName"
                      placeholder="Enter Service Provider Name"
                      [ngClass]="{'is-invalid':submitted && editServiceProviderForm.controls.serviceProviderName.errors}"
                      name="serviceProviderName">
                    <div class="invalid-feedback">
                      Service Provider Name is required
                    </div>
                  </div>
                  <div class="form-group col-md-3">
                    <label class="col-form-label" for="serviceProviderDesc">Service Provider Description <span
                        aria-hidden="true" class="symbol required" style="color:red;">*</span>
                    </label>
                    <input type="text" id="serviceProviderDesc" [readOnly]="!permissions.includes('Edit')"
                      autocomplete="off" class="form-control" (paste)="onPaste($event)"
                      (keypress)="OnlyCharacterAllowed($event)" required formControlName="serviceProviderDesc"
                      placeholder="Enter Service Provider Description"
                      [ngClass]="{'is-invalid':submitted && editServiceProviderForm.controls.serviceProviderDesc.errors}"
                      name="serviceProviderDesc">
                    <div class="invalid-feedback">
                      Service Provider Description is required
                    </div>
                  </div>
                  <div class="form-group col-md-3">
                    <label class="col-form-label" for="serviceProviderCode">Service Provider Code <span
                        aria-hidden="true" class="symbol required" style="color:red;">*</span>
                    </label>
                    <input type="text" id="serviceProviderCode" [readOnly]="!permissions.includes('Edit')"
                      autocomplete="off" class="form-control" (paste)="onPaste($event)"
                      (keypress)="OnlyCharacterAllowed($event)" required formControlName="serviceProviderCode"
                      placeholder="Enter Service Provider Code"
                      [ngClass]="{'is-invalid':submitted && editServiceProviderForm.controls.serviceProviderCode.errors}"
                      name="serviceProviderCode">
                    <div class="invalid-feedback">
                      Service Provider Code is required
                    </div>
                  </div>
                  <div class="form-group col-md-3">
                    <label class="col-form-label" for="contactNumber">Contact Number <span aria-hidden="true"
                        class="symbol required" style="color:red;">*</span>
                    </label>

                    <div class="input-group mb-3">

                      <div class="input-group-prepend" *ngIf="permissions.includes('Edit')">
                        <select class="form-control" id="contactCountryCode" formControlName="contactCountryCode"
                          name="contactCountryCode" required>
                          <option *ngFor="let country of countryDropDown" [value]="country.phoneCode">
                            +{{country.phoneCode}}</option>
                        </select>
                      </div>
                      <div class="input-group-prepend" *ngIf="permissions.includes('Approve')" style="max-width: 70px; padding-right: 0;">
                        <input type="text" id="countryCode" readonly 
                        value="+{{this.editServiceProviderForm.value.contactCountryCode | titlecase}}" class="form-control">
                      </div>
                    
                    
                      <input style="margin-left: 0;" type="text" class="form-control" [readOnly]="!permissions.includes('Edit')"
                        (paste)="onPaste($event)" autocomplete="off" id="phone" required
                        placeholder="Enter Contact Number" maxlength="10" formControlName="contactNumber"
                        onkeypress="return event.keyCode === 8 || event.charCode >= 48 && event.charCode <= 57"
                        [ngClass]="{'is-invalid': submitted && editServiceProviderFormControl.contactNumber.errors}">
                    </div>
                   
                   
                    <div class="invalid-feedback" style="display: block;"
                      *ngIf="submitted && editServiceProviderFormControl?.contactNumber?.errors">
                      <div *ngIf="editServiceProviderFormControl?.contactNumber?.errors?.required">
                        Contact Number is required.
                      </div>
                      <div *ngIf="editServiceProviderFormControl?.contactNumber?.errors?.pattern">
                        Please enter valid contact number.
                      </div>
                    </div>



                    <div class="invalid-feedback" style="display: block;" 
                      *ngIf="submitted && editServiceProviderFormControl?.contactCountryCode?.errors">
                      <div *ngIf="editServiceProviderFormControl?.contactCountryCode?.errors?.required">
                        Country Code is required.
                      </div>
                    </div>

                  </div>

                </div>
                <div class="row d-flex">
                  <div class="form-group col-md-4" *ngIf="permissions.includes('Edit')">
                    <label class="col-form-label" for="country">Country <span aria-hidden="true" class="symbol required"
                        style="color:red;">*</span>
                    </label>
                    <input type="text" id="countryName" readonly
                      value="{{this.editServiceProviderForm.value.countryName}}" class="form-control">

                    <div class="invalid-feedback">
                      <div>
                        Country is required.
                      </div>
                    </div>
                  </div>
                  <div class="form-group col-md-4" *ngIf="permissions.includes('Approve')">
                    <label class="col-form-label" for="country">Country <span aria-hidden="true" class="symbol required"
                        style="color:red;">*</span>
                    </label>
                    <input type="text" id="countryName" readonly
                      value="{{this.editServiceProviderForm.value.countryName}}" class="form-control">

                    <!-- <ng-select id="country" placeholder="Select Country"  formControlName="country" name="country" class="disable-class" >
                        <ng-option *ngFor="let country of countryDropDown" value="{{country.id}}">{{country.name}}</ng-option>
                      </ng-select>   
                      <div class="invalid-feedback" >
                          <div>
                              Country is required.
                          </div>
                      </div> -->
                  </div>
                  <div class="form-group col-md-4">
                    <label class="col-form-label" for="emailId">Email ID <span aria-hidden="true"
                        class="symbol required" style="color:red;">*</span>
                    </label>
                    <input type="text" id="emailId" [readOnly]="!permissions.includes('Edit')" autocomplete="off"
                      (paste)="onPaste($event)" class="form-control" required formControlName="emailId"
                      placeholder="Enter Email ID"
                      [ngClass]="{'is-invalid':submitted && editServiceProviderForm.controls.emailId.errors}"
                      name="emailId">
                    <div class="invalid-feedback" style="display: block;"
                      *ngIf="submitted && editServiceProviderFormControl?.emailId?.errors">
                      <div *ngIf="editServiceProviderFormControl?.emailId?.errors?.required">
                        Email Id is required.
                      </div>
                      <div *ngIf="editServiceProviderFormControl?.emailId?.errors?.pattern">
                        Please enter valid email id.
                      </div>
                    </div>
                  </div>
                  <!-- <div class="form-group col-md-3">
                          <label class="col-form-label" for="status">Status <span aria-hidden="true"
                                  class="symbol required" style="color:red;">*</span>
                          </label>
                          <ng-select formControlName="status" placeholder="Select Status" (change)="statusOnChange($event)" id="status" name="status" required  [ngClass]="{'is-invalid':submitted && editServiceProviderForm.controls.status.errors}" >
                              <ng-option value="ACTIVE">Active</ng-option>
                              <ng-option value="INACTIVE">Inactive</ng-option>
                            </ng-select>
                          <div class="invalid-feedback" >
                              <div >
                                  Status is required.
                              </div>
                          </div>
                      </div> -->

                  <div class="form-group col-md-4">
                    <label class="col-form-label" for="maxBalance">Maximum Balance <span aria-hidden="true"
                        class="symbol required" style="color:red;">*</span>
                    </label>
                    <input type="text" id="maxBalance" [readOnly]="!permissions.includes('Edit')" autocomplete="off"
                      maxlength="8" class="form-control" required formControlName="maxBalance"
                      placeholder="Enter Maximum Balance"
                      [ngClass]="{'is-invalid':submitted && editServiceProviderForm.controls.maxBalance.errors}"
                      name="maxBalance"
                      onkeypress="return event.keyCode === 8 || event.charCode >= 48 && event.charCode <= 57">
                    <div class="invalid-feedback">
                      Maximum Balance is required
                    </div>
                  </div>
                  <div class="row d-flex">
                    <div class="form-group col-md-3 " *ngIf="permissions.includes('Edit')">
                      <label class="col-form-label">Status <span aria-hidden="true" class="symbol required"
                          style="color:red;">*</span></label>
                      <input type="text" id="productName" readonly
                        value="{{this.editServiceProviderForm.value.status | titlecase}}" class="form-control">
                    </div>
                    <div class="form-group col-md-3 " *ngIf="permissions.includes('Approve')">
                      <label class="col-form-label" for="status">Status <span aria-hidden="true" class="symbol required"
                          style="color:red;">*</span>
                      </label>
                      <ng-select id="status" placeholder="Select Status" (change)="statusChangeCheck($event)"
                        formControlName="status" required
                        [ngClass]="{'is-invalid':submitted && editServiceProviderForm.controls.status.errors}"
                        name="status">
                        <ng-option value="ACTIVE">Active</ng-option>
                        <ng-option value="INACTIVE">Inactive</ng-option>
                      </ng-select>
                      <div class="invalid-feedback">
                        <div>
                          Status is required
                        </div>
                      </div>
                    </div>
                    <div class="form-group col-md-3 " style="margin-top: 25px;">
                      <button type="button" class="btn btn-primary" (click)="statusChangeApi()"
                        *ngIf="permissions.includes('Approve')">Change Status</button>
                    </div>
                    <div class="row d-flex" *ngIf="permissions.includes('Edit')">


                      <div class="form-group col-md-3" *ngIf="permissions.includes('Edit')">
                        <label class="col-form-label" for="category">Category
                        </label>
                        <ng-select [items]="categoryDropDown" placeholder="Select Category" bindLabel="name"
                          (change)="categoryChange($event)" id="category" formControlName="category" name="category">
                        </ng-select>

                        <div class="invalid-feedback">
                          <div>
                            Category is required.
                          </div>
                        </div>
                      </div>

                      <div class="form-group col-md-3" *ngIf="permissions.includes('Edit')">
                        <label class="col-form-label" for="subCategory">Sub Category
                        </label>
                        <ng-select [items]="subCategoryDropDown" placeholder="Select Subcategory" bindLabel="name"
                          (change)="subCategoryChange($event)" id="subCategory" formControlName="subCategory"
                          name="subCategory">
                        </ng-select>
                        <div class="invalid-feedback">
                          <div>
                            Sub Category is required.
                          </div>
                        </div>
                      </div>



                      <div class="form-group col-md-3">
                        <label class="col-form-label" for="product">Product
                        </label>
                        <ng-select [items]="productDropDown" placeholder="Select Product" bindLabel="name" id="id"
                          formControlName="product" name="product">

                        </ng-select>
                        <div class="invalid-feedback">
                          <div>
                            Product is required.
                          </div>
                        </div>
                      </div>
                      <div class="form-group col-md-3" style="margin-top:40px;">
                        <button type="button" (click)="addProduct()" class="btn btn-primary">Add Product</button>
                      </div>
                    </div>

                  </div>

                </div>

                <br>
                <div class="row d-flex">

                  <div class="form-group col-md-4" *ngFor="let productData of productTableList;let i=index">
                    <div class="card border-light cards">
                      <div class="row">
                        <div class="col-sm-4 mt-4">
                          <img [src]="productTableList[i].productIcon" style="width: 95%;" alt="Card image cap"
                            class="card-img-top">
                        </div>
                        <div class="col-sm-8">
                          <div class="card-header position-relative">
                            <h5>{{productTableList[i].productName}}</h5>
                            <button type="button" *ngIf="permissions.includes('Edit')" (click)="deleteProduct(i, $event)"
                              class="close" aria-label="Close">
                              <i class="fa fa-times-circle" aria-hidden="true"></i>
                            </button>
                          </div>
                          <div class="card-body">
                            <p class="card-text" style="font-size: 10px;">{{productTableList[i].categoryName}} |
                              {{productTableList[i].subCategoryName}}</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                </div>
                <div class="row">
                  <div class="form-group col-md-12 text-right">
                    <button type="submit" class="btn btn-primary" *ngIf="permissions.includes('Edit')">Save &
                      Next</button>
                    <button type="button" class="btn btn-primary" id="cancelButton" (click)="switchTab('commission')"
                      *ngIf="(permissions.includes('View') || permissions.includes('Approve'))">Next</button>
                    <button type="button" class="btn btn-secondary" id="cancelButton"
                      (click)="cancelButton()">Cancel</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </form>
    </div>
    <div id="commission" class="tab-pane fade p-4 active show"
      [ngStyle]="{ 'display': activeTab === 'commission'? 'block' : 'none'}">
      <form #editCommission="ngForm" (ngSubmit)="saveCommission(editCommission.value)" [formGroup]="editCommissionForm">
        <div class="row">
          <div class="col-lg-12">
            <div class="card border-0 shadow-none text-center">
              <div class="card-body">
                <div class="row d-flex">
                  <div class="form-group col-md-4">
                    <ng-select id="product" (change)="productChange($event)" placeholder="Select Product"
                      [items]="productTableList" bindLabel="productName" bindValue="id" formControlName="product"
                      required placeholder="Select Product"
                      [ngClass]="{'is-invalid':submittedCommission && editCommissionForm.controls.product.errors}"
                      name="product">
                    </ng-select>
                    <div class="invalid-feedback">
                      <div>
                        Product | Category | Subcategory is required.
                      </div>
                    </div>
                  </div>

                </div>
                <br>
                <div class="row d-flex">
                  <div class="form-group col-md-8">
                    <div class="text-left">
                      <div class="d-flex">
                        <h5 class="col-form-label" for="fullName" *ngIf="selectedProductVisible">
                          {{selectedProduct.productName}} | {{selectedProduct.categoryName}} |
                          {{selectedProduct.subCategoryName}}</h5>
                      </div>
                    </div>
                  </div>
                  <div class="form-group col-md-4">
                    <div class="text-right">
                      <button type="button" class="btn btn-primary"
                        *ngIf="(permissions.includes('Edit') && selectedProductVisible)"
                        (click)="cloneData()">Copy</button>
                      <button type="button" class="btn btn-primary"
                        *ngIf="(permissions.includes('Edit') && selectedProductVisible)"
                        (click)="addSlabCheck()">New</button>
                      <button type="button" class="btn btn-primary" *ngIf="permissions.includes('Approve')"
                        (click)="reviewSlab($event)">Review</button>
                    </div>
                  </div>

                </div>
                <div class="row d-flex" *ngIf="showSlabMessage">
                  <h4 style="color: red;">Rates are not yet configured for this product</h4>
                </div>
                <br>

                <br>
                <div class="row d-flex" *ngIf="showSavedTable">
                  <div class="row mb-0" style="min-height: 270px">
                    <div class="col-12 col-xl-12 grid-margin stretch-card ag-theme-alpine" style="margin-bottom: 0px">
                      <ag-grid-angular [enableCellTextSelection]=true (gridReady)="onGridReadySavedData($event)"
                        [columnDefs]="savedDataColumn" [defaultColDef]="defaultColDef" [enableCellTextSelection]=true
                        [rowData]="savedSlabData" [rowModelType]="" [rowSelection]="'single'"
                        [suppressPaginationPanel]="true" style="width: 100%; height: auto;">
                      </ag-grid-angular>
                    </div>
                  </div>
                </div>
                <br>
                <div class="row d-flex" *ngIf="showDataTable">
                  <hr>
                  <div class="text-right">
                    <button type="button" class="btn btn-primary" (click)="addRow()">Add Slab</button>
                    <button type="button" class="btn btn-primary" (click)="selectSpecificAmount()">Add Specific
                      Amount</button>
                    <button type="button" class="btn btn-secondary" id="cancelButton"
                      (click)="clearButton()">Clear</button>
                  </div>
                </div>
                <br>
                <div class="row d-flex" *ngIf="showDataTable">

                  <div class="row mb-0" style="min-height: 270px">
                    <div class="col-12 col-xl-12 grid-margin stretch-card ag-theme-alpine" style="margin-bottom: 0px">
                      <ag-grid-angular [enableCellTextSelection]=true (gridReady)="onGridReady($event)"
                        (cellValueChanged)="onCellValueChanged($event)" [columnDefs]="tableSelectedColumn"
                        [defaultColDef]="defaultColDef" [enableCellTextSelection]=true [rowData]="finalCommissionData"
                        [rowModelType]="" [rowSelection]="'single'" [suppressPaginationPanel]="true"
                        style="width: 100%; height: auto;">
                      </ag-grid-angular>
                    </div>
                  </div>
                </div>
                <br>
                <br>
                <div class="row d-flex">
                  <div class="text-right">
                    <button type="button" class="btn btn-secondary" id="cancelButton"
                      (click)="switchTab('service')">Back</button>
                    <button type="submit" class="btn btn-primary"
                      *ngIf="(showDataTable && permissions.includes('Edit'))">Save</button>
                    <button type="button" class="btn btn-danger" id="cancelButton"
                      (click)="cancelButton()">Cancel</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </form>
    </div>
  </div>
  <app-modal #openReviewSlab [modalConfig]="modalServiceProviderReview" style="width: 1200px;">

    <h4 class="text-center">Review Changes</h4>
    <div *ngIf="showOldSlab">
      <br>
      <br>
      <h5>Old Slab</h5>
      <div class="row d-flex">
        <div class="form-group col-md-12 ">
          <div class="row mb-0" style="min-height: 270px">
            <div class="col-12 col-xl-12 grid-margin stretch-card ag-theme-alpine" style="margin-bottom: 0px">
              <ag-grid-angular [enableCellTextSelection]=true (gridReady)="onGridReady($event)"
                [columnDefs]="savedDataColumn" [defaultColDef]="reviewSlabCol" [enableCellTextSelection]=true
                [rowData]="oldSlab" [rowModelType]="" [rowSelection]="'single'" [suppressPaginationPanel]="true"
                style="width: 100%; height: auto;">
              </ag-grid-angular>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div *ngIf="showNewSlab">
      <br>
      <br>
      <h5>New Slab</h5>
      <div class="row d-flex">
        <div class="form-group col-md-12 ">
          <div class="row mb-0" style="min-height: 270px">
            <div class="col-12 col-xl-12 grid-margin stretch-card ag-theme-alpine" style="margin-bottom: 0px">
              <ag-grid-angular [enableCellTextSelection]=true (gridReady)="onGridReady($event)"
                [columnDefs]="savedDataColumn" [defaultColDef]="reviewSlabCol" [enableCellTextSelection]=true
                [rowData]="newSlab" [rowModelType]="" [rowSelection]="'single'" [suppressPaginationPanel]="true"
                style="width: 100%; height: auto;">
              </ag-grid-angular>
            </div>
          </div>
        </div>
      </div>
    </div>
 
      <div class="form-group col-md-12">
        <div class="text-center">
          <input type="text" autocomplete="off" id="inputBorder" placeholder="Enter the Remarks"
            [(ngModel)]="slabRemarks">
        </div>
      </div>
  


    <div class="row d-flex">
      <div class="form-group col-md-12 text-center">
        <button type="button" class="btn btn-primary" (click)="slabStatusChange('ACTIVE')">Approve</button>
        <button type="button" class="btn btn-secondary" id="cancelButton"
          (click)="slabStatusChange('REJECTED')">Reject</button>
      </div>
    </div>

  </app-modal>

  <app-modal #statusChange [modalConfig]="modalStatusChange" style="width: 1200px;">

    <br>
    <h4 class="text-center">Are you sure ?</h4>
    <br>
    <p class="text-center">Services will get hampered for the below mentioned products as only one Service Provider is
      available.</p>
    <hr class="new5">
    <div class="row">
      <div class="col-sm-3 mb-2 text-center" *ngFor="let productData of productTableList">
        <div class="card text-center border-light cardStyle" style="width: 10rem; height: 8rem;">
          <div class="card-body">
            <br>
            <h5 class="card-title">{{productData.productName}}</h5>
          </div>
        </div>
      </div>
    </div>

    <br>
    <div class="row d-flex">
      <div class="form-group col-md-12 text-center">
        <button class="btn btn-primary" (click)="confirmModal()">Confirm</button>
        <button class="btn btn-secondary" id="cancelButton" (click)="closeModalBlocked($event)">Cancel</button>
      </div>
    </div>

  </app-modal>